<template>
    <div class="salesforce-reexport">
        <h1 class="title">Reexport eines Celeraone-Nutzers zu Salesforce</h1>
        <v-form v-model="valid" v-on:submit.prevent>
            <v-text-field v-model="ssoId" label="SSO-ID" :rules="ssoIdRules" :clearable="true" :disabled="loading">
            </v-text-field>
            <v-btn block class="ml-0 mr-0 drei_60-btn" :disabled="!valid || loading" :loading="loading" @click="submit">
                Reexport
            </v-btn>
        </v-form>
    </div>
</template>
<script>
import { mapMutations } from 'vuex';
import Api from '@/api';

export default {
    name: 'SalesforceReexport',
    data() {
        return {
            valid: false,
            loading: false,
            ssoId: '',
            ssoIdRules: [
                v => !!v || 'SSO-ID darf nicht leer sein.',
            ],
        };
    },
    methods: {
        submit() {
            this.loading = true;
            Api.salesforce.reexport(this.ssoId)
                .then(() => {
                    this.success(`Nutzer mit SSO-ID '${this.ssoId}' wurde erfolgreich in die API-Proxy-Queue eingefügt.`);
                })
                .catch(() => {
                    this.error(`Nutzer mit SSO-ID '${this.ssoId}' konnte nicht nicht in die API-Proxy-Queue eingefügt werden.`);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        ...mapMutations('snackbar', ['success', 'error']),
    },
};

</script>
<style scoped lang="scss"></style>
